<template>
    <div id="collections-benefits">
        <div v-for="item in items" class="collections-benefit">
            <img
                :data-src="`${$scope.CDN_IMAGES}/images/site/hotsite/parcerias/${item.image}?auto=compress,format&q=65`"
                :style="item.imageStyle"
                class="lazy lazy-fade"
            />
            <div class="ml">
                <h3 v-if="item.title" class="text-accent mt-0">
                    {{ item.title }}
                </h3>
                <p class="mx-0 my-0">{{ item.text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../../common/common';

    export default {
        name: 'PartnersPageBenefits',
        props: ['items'],
        mounted() {
            updateLazyLoad();
        },
    };
</script>
